import React, { Component } from 'react';
import { useContext, useEffect, useState } from "react";
import { Modal, FormControl, InputGroup } from 'react-bootstrap';
import { settingvalidate ,cmsvalidate, validliquiditytoken} from '../../hooks/kycvalidation';
import { updatecmshook } from '../../hooks/usebackend'
import {updateAPR} from "../../hooks/uselockedstack"
import {API_URL} from '../../config/env'
import proof from "../../images/proof.webp"

class Editaprmodal extends Component {
    constructor(props) {
        console.log("propssssssssssssssssssss",props);
        super(props);
        this.state = {
            
            editaprModal: true,
            title:"",
            image: "",
            name: "",
            pid:'',
            errors: {}

        };
    }

    componentDidMount() {
        if (!this.state.name && !this.state.image  ) {
            this.setState({ "name": this.props.data.name });
            this.setState({ "image": this.props.data.image })
            this.setState({ "title": this.props.data.emissionPerBlock })
            
        }
    }


    handleedit = async(props)=>{
        this.setState({disableButton: true})
        try {
            let payload = {
                pid : this.props.pid,
                title : this?.state?.title,
               
            }
       if(payload){
        console.log('propsdata--',payload);
        let result = await updateAPR(this.props.pid,this?.state?.title);
        if(result){
            this.props.onDismiss();
        }
        // console.log("result",result)
      
        // this.props.getcms()
       }
            
        } catch (error) {
            console.log("error_updateAPR",error);
            
        }
        this.setState({disableButton:false})
        
        
                
    }

    onImageChange = event => {
        if (event.target.files && event.target.files[0]) {
            let img = event.target.files[0];
            this.setState({
                image: img
            });
        }
    };

    render() {


        const { editaprModal } = this.state


        return (



            <Modal className="wallet-modal" show={editaprModal} centered size="md">
                <Modal.Header className='pt-3 header_odal_head'>
                    <h3 className="sec-head ">Edit APR</h3>
                    <button type="button" class="close" onClick={() => this.props.onDismiss()}><span aria-hidden="true">×</span><span class="sr-only">Close</span></button>

                </Modal.Header>
                <Modal.Body className="select-wallet modal_body pt-0 pb-0 px-0">

                    <div className="wallet-lists px-2">

                        <div className='mod_pad_space pt-0'>
                            <div className='row'>
                                <div className='col-12 col-md-12 px-1 mb-3'>

                                </div>
                                {/* <div className='col-12 col-md-12 px-1 mb-3'>
                                    <p className='input_desc_sm'>Setting Name</p>
                                    <div className="inputs input-groups">
                                        <InputGroup className="">
                                            <FormControl id="settingname" placeholder="Setting Name"
                                                aria-describedby="basic-addon2"
                                                value={this.state.settingname}
                                                onChange={(e) => {
                                                    this.setState({ "settingname": e?.target?.value })
                                                }}
                                            />

                                        </InputGroup>
                                        <span className="text-danger f-12 d-block text-left">{this?.state?.errors?.settingvalue}</span>
                                    </div>
                                </div>

                                <div className='col-12 col-md-12 px-1 mb-3'>
                                    <p className='input_desc_sm'>Setting Value</p>
                                    <div className="inputs input-groups">
                                        <InputGroup className="">
                                            <FormControl id="hardcap" value={this?.state?.settingvalue} placeholder="Setting Value"
                                                aria-describedby="basic-addon2"
                                                onChange={(e) => {
                                                    this.setState({ "settingvalue": e?.target?.value })
                                                }}
                                            />

                                        </InputGroup>
                                        <span className="text-danger f-12 d-block text-left">{this?.state?.errors?.settingvalue}</span>
                                    </div>
                                </div> */}


                                <div className="row mb-3 px-3">
                                   <div className='col-12 col-sm-12 col-md-12 px-1 mb-3'>
                                    <p className='input_desc_sm'>APR Fee</p>
                                     <input type='text' className='formcontrol'
 
                                      placeholder='0%'
                                      name = "title"
                                      value= {this?.state?.title}
                                      onChange={(e) => {
                                        this.setState({ "title": e?.target?.value })
                                      }}  
                                      />
                                        {/* <span className="text-danger f-12 d-block text-left">{this?.state?.errors?.title}</span> */}
 
                                    </div>
                                </div>
                               

                                <div className='col-12 col-md-12 px-1 text-center'>
                                    <button className="get-started-btn mt-2" onClick={this.handleedit} disabled={this.state.disableButton}>
                                        Save
                                    </button>

                                </div>
                            </div>

                        </div>
                    </div>
                </Modal.Body>
            </Modal>



        )
    }

}


export default Editaprmodal